const DataHygieneRoutes = {
    Emails: 'emails',
    PhoneNumbers: 'phone-numbers',
    Addresses: 'addresses',
    Duplicates: 'duplicates',
};

export { DataHygieneRoutes };
